import { getAccessToken } from "context/AuthContext";
import { trackPromise } from "react-promise-tracker";
import User from "context/User";
import { fetchWithTimeout, handleResponse } from "./BaseAPI";

const API_U_URL = process.env.REACT_APP_U_API_URL;
const STRIPE_API_URL = process.env.REACT_APP_STRIPE_API_URL;

export const SUBSCRIPTION_TYPES = {
  HISTORY: "history",
  VALID: "subscriptions_valid",
}

export const PRODUCT_NAMES = {
  URL_CHECKER_MONTHLY: "url-checker-monthly",
  URL_CHECKER_PAY_AS_YOU_GO: "url-checker-pay-as-you-go",
  URL_CHECKER_ADD_ON: "url-checker-add-on"
};

async function requestHeaders(isAdmin = false) {
  const accessToken = await getAccessToken(User.VERITAS);
  
  const requestHeaders = new Headers();
  requestHeaders.append('Accept', 'application/json');
  requestHeaders.append('Content-Type', 'application/json');
  if (accessToken) {
    requestHeaders.append("jwtToken", `${accessToken}`);
  }
  if (!isAdmin) {
    const user = User.getUserInfo();
    requestHeaders.append("email", `${user.email}`);
  }
  return requestHeaders;
}

// Get payment plans (Stripe products)
export async function getPaymentPlans(productName) {
  const url = `${STRIPE_API_URL}/products?productName=${productName || ""}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await response.json();
}

// Create a Stripe payment
export async function createStripePayment(params) {
  const url = `${STRIPE_API_URL}/create`;
  const response = await trackPromise(fetchWithTimeout(url, {
    method: "POST",
    headers: await requestHeaders(),
    body: JSON.stringify(params),
  }));
  return await response.json();
}

// Get all payments
export async function getPaymentList(type = SUBSCRIPTION_TYPES.HISTORY) {
  const user = User.getUserInfo();
  // organization key: the e-mail itself for free e-mail providers, otherwise the domain
  const domain = encodeURIComponent(user.domain);
  const url = `${API_U_URL}/payment/list/${domain}`;
  const headers = await requestHeaders(true);
  headers.append("type", type);
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: headers
  }));
  return await response.json();
}

export async function getAdminPaymentList(type = SUBSCRIPTION_TYPES.HISTORY) {
  const user = User.getUserInfo();
  const url = `${API_U_URL}/payment/list`;
  const headers = await requestHeaders();
  headers.append("type", type);
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: headers
  }));
  return await response.json();
}

// Get subscription info
export async function getSubscription(isAdmin = false) {
  const url = `${API_U_URL}/payment/subscription`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders(isAdmin)
  }));
  return await response.json();
}

// Get remaining credits
export async function getRemainingCredits() {
  const url = `${API_U_URL}/payment/credits`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await response.json();
}

export async function cancelPaymentSubscription(subscriptionId) {
  const url = `${API_U_URL}/payment/cancel/${subscriptionId}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await response.json();
}

export async function getPaymentSpecific(stripeId) {
  const url = `${API_U_URL}/payment/specific/${stripeId}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await response.json();
}